<template>
  <div class="relative min-h-screen bg-[#FDF9EE]">
    <div
      class="absolute top-0 left-0 w-full h-[23%] tablet:landscape:h-[30%] desktop:landscape:h-[50%] laptop:h-[50%] bg-[#2459A8]">
    </div>
    <div
      class="container !max-w-full laptop:!max-w-[1320px] largeDesktop:!max-w-[1600px] laptop:grid laptop:h-[100vh] laptop:!p-0"
      :class="isShowHeader ? '' : 'content-around'">
      <!-- class="relative mobile:pt-[11vh] laptop:pt-[10vh] largeDesktop:pt-[12vh] mobile:pb-[10px] tablet:pb-2 desktop:pb-0 tablet:landscape:pb-2 desktop:landscape:pb-0"> -->
      <div
        :class="isShowHeader ? 'pt-[80px] laptop:pt-[100px] laptop:pb-[50px] largeDesktop:pb-[100px] flex flex-col justify-between gap-[20px] laptop:gap-[0px]' : 'mobile:pt-[11vh] laptop:pt-[10vh] largeDesktop:pt-[12vh] mobile:pb-[10px] tablet:pb-2 desktop:pb-0 tablet:landscape:pb-2 desktop:landscape:pb-0'">
        <paymentFailed v-if="user" />
        <div class="relative z-10 laptop:grid grid-cols-3 laptop:items-stretch gap-[20px] ">
          <div
            class="transform transition-transform duration-[500ms] hover:scale-[1.02] col-span-2 relative laptop:top-[6vh] largeDesktop:top-[calc(110vh-100vh)] mobile:flex justify-end laptop:block mb-[30px] laptop:m-0">
            <img src="../../assets/images/myHappyHomeFamilyImg.png" alt="Family Image"
              class="w-[70%] laptop:w-[80%] tablet:landscape:w-[55%] desktop:landscape:w-[80%] largeDesktop:w-full animate-float ">
          </div>
          <div
            class="rounded-[20px] p-[20px] tablet:mt-[20px] largeDesktop:p-[30px] flex flex-col justify-between shadow-[0px_0px_4px_0px_#0000001A] bg-[#fff] h-[calc(100vh-300px)] laptop:h-auto mobile:!min-h-[450px] tablet:landscape:!min-h-[500px] desktop:landscape:!min-h-max tablet:!min-h-max">
            <div
              class="grid grid-cols-2 gap-[15px] largeDesktop:gap-[25px] tablet:w-[70%] tablet:mx-auto laptop:w-full ">
              <component :is="'router-link'" :to="item.link" v-for="item in dashboardCard" :key="item.label"
                @click="handleCardClick(item)"
                class="transform laptop:hover:scale-[1.1] active:scale-[0.98] group no-underline flex flex-col items-center justify-center gap-[20px] shadow-[0px_0px_10px_0px_#cccccc61] py-[30px] tablet:py-0 w-full mobile:h-auto tablet:h-[180px] laptop:h-[130px] largeDesktop:h-[200px] rounded-[20px] transition-all duration-500 cursor-pointer border-opacity-50 border-[1px] border-[#F5B134]"
                :style="{ backgroundColor: isHover[item.label] ? item.bgColor : '#FDF9EE' }"
                @mouseenter="!isMobile && (isHover[item.label] = true)"
                @mouseleave="!isMobile && (isHover[item.label] = false)">
                <div
                  class="w-[60px] h-[60px] largeDesktop:w-[80px] largeDesktop:h-[80px] flex items-center justify-center rounded-full transition-colors duration-300"
                  :style="{ backgroundColor: isHover[item.label] ? '#fff' : item.bgColor }">
                  <img :src="require(`@/assets/images/${item.icon}`)" :alt="item.label"
                    class="w-[30px] h-[30px] largeDesktop:w-[40px] largeDesktop:h-[40px] object-contain"
                    v-show="!isHover[item.label]" />
                  <img :src="require(`@/assets/images/${item.hoverIcon}`)" :alt="item.label"
                    class="w-[30px] h-[30px] largeDesktop:w-[40px] largeDesktop:h-[40px] object-contain"
                    v-show="isHover[item.label]" />
                </div>
                <h6
                  class="m-0 text-[18px] largeDesktop:text-[20px] font-roboto font-medium transition-colors duration-300"
                  :style="{ color: isHover[item.label] ? '#fff' : '#333333' }">
                  {{ item.label }}
                </h6>
              </component>
            </div>
            <div class="largeDesktop:mt-[20px]">
              <copyright />
              <div class="mt-[5px]">
                <termsAndPrivacyComponent />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bg-[#000]/30" id="comingsoonModal" ref="comingsoonModal" tabindex="-1"
      aria-labelledby="comingsoonModal" aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered w-full right-0 left-0 !mx-auto mobile:!px-3 tablet:!w-[500px] laptop:!px-0 !absolute !top-0 !m-0 h-full">
        <div class="modal-content !p-2.5 !pb-4">
          <div class="relative rounded-[10px] overflow-hidden h-[80px] bg-customBlue-100">
            <button type="button"
              class="absolute top-3 right-[10px] w-[30px] h-[30px] z-50 focus:!outline-none focus:!shadow-none"
              data-bs-dismiss="modal" aria-label="Close" @click="hideComingSoonModal">
              <img src="../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                class="w-[30px] h-[30px] object-contain">
            </button>
            <h3
              class="absolute top-0 left-0 w-full h-full flex items-center justify-start m-0 font-poppins font-semibold text-center text-[20px] px-[15px] text-white">
              No claims found
            </h3>
          </div>
          <div class="modal-body !p-0 mobile:mt-[10px] tablet:my-[25px]">
            <div class="text-center font-poppins">
              <!-- <h4 class="text-lg font-semibold text-customBlue-100">No claims found
              </h4> -->
              <p class="font-poppins text-center max-w-[100%] text-base mx-auto text-[#666666]">You haven’t created any
                claims yet.</p>
              <div class="flex justify-center pt-[25px]">
                <button @click="hideComingSoonModal"
                  class="uppercase font-poppins font-medium mobile:text-[16px] tablet:text-lg py-1.5 px-[30px] tablet:py-2 tablet:px-[52px] rounded-full border-[1px] transition-all duration-300 border-[#F8B134] text-white 
                  bg-customYellow-100 laptop:hover:bg-gradient-to-r laptop:hover:from-[#F8B134] laptop:hover:to-[#FDF9EE] laptop:hover:!text-black-100">
                  Dismiss
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import copyright from '../nest_views/copyright.vue';
import termsAndPrivacyComponent from '../../components/authComponent/termsAndPrivacyComponent.vue';
import paymentFailed from "../../components/partialComponent/paymentFailedHeader.vue";
import {
  mapGetters
} from "vuex";
export default {
  components: {
    copyright,
    termsAndPrivacyComponent,
    paymentFailed
  },
  data() {
    return {
      dashboardCard: [
        { icon: 'plan-icon.svg', hoverIcon: 'planHover-icon.svg', bgColor: '#F5B134', label: 'Protection Plans', link: '/plans' },
        { icon: 'claim-icon.svg', hoverIcon: 'claimHover-icon.svg', bgColor: '#F5B134', label: 'Claim History', link: '/work-order/list' },
        { icon: 'purchase-history-icon.svg', hoverIcon: 'purchase-historyHover-icon.svg', bgColor: '#F5B134', label: 'Purchased Plans', link: '/purchases' },
        { icon: 'billing-history-icon.svg', hoverIcon: 'billing-historyHover-icon.svg', bgColor: '#F5B134', label: 'Billing History', link: '/billings/methods' },
      ],
      isHover: {},
      isMobile: false,
      user: JSON.parse(localStorage.getItem('user')) ?? null,
      isShowHeader: false


    };
  },
  computed: {
    ...mapGetters([
      "failedInvoices",
    ]),
  },
  created() {
    this.dashboardCard.forEach(item => {
      // Direct assignment works fine in Vue 2.7+
      this.isHover[item.label] = false;
    });
  },
  mounted() {
    this.isMobile = window.innerWidth < 1275;
  },
  watch: {
    failedInvoices: function (data) {


      if (this.failedInvoices.invoices.length > 0) {
        this.isShowHeader = true
      }
      else {
        this.isShowHeader = false
      }
    },
  },
  methods: {

    handleCardClick(item) {
      if (item.comingSoon) {
        const { Modal } = require('bootstrap');
        const modalEl = this.$refs.comingsoonModal;
        let modal = Modal.getInstance(modalEl);
        if (!modal) {
          modal = new Modal(modalEl, {
            backdrop: 'static',
            keyboard: false
          });
        }
        modal.show();
      }
    },
    hideComingSoonModal() {
      const { Modal } = require('bootstrap');
      const modalEl = this.$refs.comingsoonModal;

      if (!modalEl) return;

      let modal = Modal.getInstance(modalEl);

      if (modal) {
        modal.hide();
      }

      // Safety: agar kisi wajah se event fire na ho
      document.documentElement.style.overflow = '';
    }
  }
}
</script>
